<template>
  <div id="postdetails">
    <section class="is-fullheight">
      <Navigation></Navigation>
      <div class="has-margin-top-80 has-margin-bottom-40">
        <div class="container">
          <div class="content">
            <div class="columns">
              <div class="column">
                <div class="item-content">
                  <div class="is-size-4 has-text-primary">
                    <span v-if="post.industry === 'audi-e-tron'">{{ $t('post.input-option-audi-e-tron') }}</span>
                    <span v-else-if="post.industry === 'citroen-berlingo'">{{ $t('post.input-option-citroen-berlingo') }}</span>
                    <span v-else-if="post.industry === 'ds-ds3-crossback-e-tens'">{{ $t('post.input-option-ds-ds3-crossback-e-tense') }}</span>
                    <span v-else-if="post.industry === 'hyundai-ioniq-electric'">{{ $t('post.input-option-hyundai-ioniq-electric') }}</span>
                    <span v-else-if="post.industry === 'hyundai-kona-electric-39-kwh'">{{ $t('post.input-option-hyundai-kona-electric-39-kwh') }}</span>
                    <span v-else-if="post.industry === 'hyundai-kona-electric-64-kwh'">{{ $t('post.input-option-hyundai-kona-electric-64-kwh') }}</span>
                    <span v-else-if="post.industry === 'jaguar-i-pace'">{{ $t('post.input-option-jaguar-i-pace') }}</span>
                    <span v-else-if="post.industry === 'kia-e-niro'">{{ $t('post.input-option-kia-e-niro') }}</span>
                    <span v-else-if="post.industry === 'mg-zs-ev'">{{ $t('post.input-option-mg-zs-ev') }}</span>
                    <span v-else-if="post.industry === 'nissan-e-nv200-combi-visia'">{{ $t('post.input-option-nissan-e-nv200-combi-visia') }}</span>
                    <span v-else-if="post.industry === 'nissan-e-nv200-visia'">{{ $t('post.input-option-nissan-e-nv200-visia') }}</span>
                    <span v-else-if="post.industry === 'nissan-leaf'">{{ $t('post.input-option-nissan-leaf') }}</span>
                    <span v-else-if="post.industry === 'peugeot-e-208'">{{ $t('post.input-option-peugeot-e-208') }}</span>
                    <span v-else-if="post.industry === 'peugeot-partner'">{{ $t('post.input-option-peugeot-partner') }}</span>
                    <span v-else-if="post.industry === 'renault-kangoo-crew-van-ze-33'">{{ $t('post.input-option-renault-kangoo-crew-van-ze-33') }}</span>
                    <span v-else-if="post.industry === 'renault-kangoo-panel-van-ze-33'">{{ $t('post.input-option-renault-kangoo-panel-van-ze-33') }}</span>
                    <span v-else-if="post.industry === 'renault-master-van-ze'">{{ $t('post.input-option-renault-master-van-ze') }}</span>
                    <span v-else-if="post.industry === 'renault-twizy'">{{ $t('post.input-option-renault-twizy') }}</span>
                    <span v-else-if="post.industry === 'renault-zoe'">{{ $t('post.input-option-renault-zoe') }}</span>
                    <span v-else-if="post.industry === 'smart-eq-forfou'">{{ $t('post.input-option-smart-eq-forfou') }}</span>
                    <span v-else-if="post.industry === 'smart-eq-fortwo-cabrio'">{{ $t('post.input-option-smart-eq-fortwo-cabrio') }}</span>
                    <span v-else-if="post.industry === 'smart-eq-fortwo-coupé'">{{ $t('post.input-option-smart-eq-fortwo-coupé') }}</span>
                    <span v-else-if="post.industry === 'tesla-model-3'">{{ $t('post.input-option-tesla-model-3') }}</span>
                    <span v-else-if="post.industry === 'tesla-model-s'">{{ $t('post.input-option-tesla-model-s') }}</span>
                    <span v-else-if="post.industry === 'tesla-model-x'">{{ $t('post.input-option-tesla-model-x') }}</span>
                    <span v-else-if="post.industry === 'volkswagen-e-golf'">{{ $t('post.input-option-volkswagen-e-golf') }}</span>
                    <span v-else-if="post.industry === 'volkswagen-e-up'">{{ $t('post.input-option-volkswagen-e-up') }}</span>  
                    &nbsp;
                    <span class="has-text-grey-light is-size-7">
                      <i>{{ post.createdOn | formatDate }}</i>
                    </span>
                  </div>
                  <span v-if="currentUser && post.userId == currentUser.uid">
                    <span class="has-text-grey-dark">&nbsp;|&nbsp;</span>
                    <a @click="editPost(post)" class="has-text-warning">{{ $t('postdetails.edit') }}</a>
                    <span class="has-text-grey-dark">&nbsp;.&nbsp;</span>
                    <a @click="deletePostModal(post)" class="has-text-danger">{{ $t('postdetails.delete') }}</a>
                  </span>
                  <div v-if="post.price">
                    <span v-if="post.currency === 'USD'" class="has-text-info">$</span>
                    <span v-else-if="post.currency === 'GBP'" class="has-text-info">£</span>
                    <span v-else-if="post.currency === 'EUR'" class="has-text-info">€</span>
                    <span v-else-if="post.currency === 'AUD'" class="has-text-info">$</span>
                    <span v-else-if="post.currency === 'CAD'" class="has-text-info">$</span>
                    <span v-else-if="post.currency === 'JPY'" class="has-text-info">JP¥</span>
                    <span v-else-if="post.currency === 'BRL'" class="has-text-info">R$</span>
                    <span v-else-if="post.currency === 'INR'" class="has-text-info">₹</span>
                    <span v-else-if="post.currency === 'CNY'" class="has-text-info">¥</span>
                    <span v-else class="has-text-info">$</span>
                    <span class="has-text-info is-size-5">{{ post.price | formatCurrency }}</span>
                    <span class="has-text-grey">({{ post.currency }})</span>
                    <span v-if="post.pricetype === 'unit'" class="is-size-7">
                    </span>
                    <span v-else-if="post.pricetype === 'monthly'" class="is-size-7 has-text-grey-light">
                      {{ $t('postdetails.per-month') }}
                    </span>
                    <span v-else-if="post.pricetype === 'annual'" class="is-size-7 has-text-grey-light">
                      {{ $t('postdetails.per-year') }}
                    </span>
                    <span v-else class="is-size-7">
                    </span>
                    <hr />
                  </div>
                  <p class="has-margin-bottom-20">{{ post.content | trimLength }}</p>
                  <div v-if="post.odometer" class="control has-margin-bottom-10">
                    {{ $t('postdetails.odometer') }}: <strong class="has-text-primary">{{ post.odometer }} {{ post.odometermetric }}</strong>
                  </div>  
                  <div v-if="post.range" class="control has-margin-bottom-10">
                    {{ $t('postdetails.range') }}: <strong class="has-text-primary">{{ post.range }} {{ post.rangemetric }}</strong>
                  </div>  
                  <div v-if="post.battery" class="control has-margin-bottom-10">
                    {{ $t('postdetails.battery') }}: <strong class="has-text-primary">{{ post.battery }} kWh</strong>
                  </div>  
                  <div v-if="post.charging" class="control has-margin-bottom-10">
                      {{ $t('postdetails.charging') }}: <strong class="has-text-primary">{{ post.charging }} kW</strong>
                  </div> 
                  <div v-if="post.acceleration" class="control has-margin-bottom-20">
                    {{ $t('postdetails.acceleration') }}: <strong class="has-text-primary">{{ post.acceleration }} seconds</strong>
                  </div>
                  
                  <!--
                  <a class="button is-primary is-rounded is-outlined has-shadow is-fullwidth">
                      <span class="has-text-light">Product Website:</span>&nbsp;{{ post.website }}
                  </a>-->
                  <div class="has-background-brand has-padding has-box-shadow has-margin-bottom-20">
                    <span class="has-text-grey-light">{{ $t('postdetails.post-contact') }}:</span>
                    <div v-if="!post.email && !post.phone">
                      <span class="has-text-brand">{{ $t('postdetails.not-yet-added') }}</span>
                    </div>
                    <div v-else>
                      <span class="has-text-brand">{{ post.email }}</span>
                      <br />
                      <span class="has-text-brand">{{ post.phone }}</span>
                    </div>
                  </div>
                  <div class="is-size-7 has-text-grey-light">{{ $t('postdetails.posted-by') }}: {{ post.userName }}</div>
                  <hr />

                  <p class="has-margin-bottom-20">
                    {{ $t('postdetails.share-options') }}:
                  </p>
                  
                  <social-sharing url="https://ecowhips.com"
                    :title="post.title"
                    :description="post.content"
                    quote="Eco Whips."
                    hashtags="evs, eco, ecocars, ecowhips"
                    twitter-user="ecowhips"
                    inline-template>
                    <div class="buttons">
                      <b-tooltip label="Email" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="email" class="button is-brand is-circle">
                          <i class="ri-mail-send-line"></i> 
                        </network>
                      </b-tooltip>
                      <b-tooltip label="Twitter" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="twitter" class="button is-brand is-circle">
                          <i class="ri-twitter-fill"></i> 
                        </network>
                      </b-tooltip>
                      <b-tooltip label="Facebook" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="facebook" class="button is-brand is-circle">
                          <i class="ri-facebook-line"></i> 
                        </network>
                      </b-tooltip>
                      <b-tooltip label="Linkedin" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="linkedin" class="button is-brand is-circle">
                          <i class="ri-linkedin-fill"></i> 
                        </network>
                      </b-tooltip>
                      <b-tooltip label="Odnoklassniki" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="odnoklassniki" class="button is-brand is-circle">
                          <i class="fab fa-odnoklassniki"></i>
                        </network>
                      </b-tooltip>
                      <b-tooltip label="Reddit" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="reddit" class="button is-brand is-circle">
                          <i class="fab fa-reddit"></i>
                        </network>
                      </b-tooltip>
                      <b-tooltip label="Skype" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="skype" class="button is-brand is-circle">
                          <i class="ri-skype-fill"></i> 
                        </network>
                      </b-tooltip>
                      <b-tooltip label="SMS" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="sms" class="button is-brand is-circle">
                          <i class="ri-discuss-line"></i> 
                        </network>
                      </b-tooltip>
                      <b-tooltip label="VK" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="vk" class="button is-brand is-circle">
                          <i class="fab fa-vk"></i>
                        </network>
                      </b-tooltip>
                      <b-tooltip label="Weibo" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="weibo" class="button is-brand is-circle">
                          <i class="ri-weibo-fill"></i> 
                        </network>
                      </b-tooltip>
                      <b-tooltip label="Whatsapp" position="is-top" type="is-black" class="has-margin-right-10">
                        <network network="whatsapp" class="button is-brand is-circle">
                          <i class="ri-whatsapp-line"></i> 
                        </network>
                      </b-tooltip>
                    </div>
                  </social-sharing>
                  <hr />
                  <div>
                    <form @submit.prevent>
                      <b-field :label="$t('postdetails.comment')">
                        <b-input v-model.trim="comment.content" :placeholder="$t('postdetails.input-ph-comment')" maxlength="120" type="text" id="comment"></b-input>
                      </b-field>
                      <b-button @click="addComment" :disabled="comment.content == ''" class="is-primary is-outlined">{{ $t('postdetails.button-comment') }}</b-button>
                    </form>
                    <hr />
                    <div v-show="postComments.length" class="comments">
                      <div v-for="comment in postComments" v-bind:key="comment" class="has-text-grey-light">
                        {{ comment.userName }}
                        <span class="is-size-7 has-text-grey-light">{{ comment.createdOn | formatDate }}</span>
                        <p>
                          {{ comment.content }}
                          <span v-if="currentUser && comment.userId == currentUser.uid">
                            <span class="has-text-grey-dark">&nbsp;|&nbsp;</span>
                            <a @click="deleteComment(comment)" class="has-text-danger">{{ $t('postdetails.delete') }}</a>
                          </span>
                        </p>
                        <hr />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-5">
                <div class="item-content">
                  <div v-if = post.imageUrl1>
                    <img :src="post.imageUrl1" :alt="post.industry" style="width: 100%" class="has-shadow has-rounded-6"/>
                  </div>
                  <div v-else-if = post.imageUrl2>
                    <img :src="post.imageUrl2" :alt="post.industry" style="width: 100%" class="has-margin-top-20 has-shadow has-rounded-6"/>
                  </div>
                  <div v-else class="box has-background-brand has-text-centered has-text-grey">
                    {{ $t('postdetails.image-not-yet-added') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav class="level is-mobile navbar is-fixed-bottom has-content-background-gradient">
        <div class="level-left">
          <div class="level-item">
            <div class="has-margin-x-md">
              <span v-if="post.industry === 'audi-e-tron'">{{ $t('post.input-option-audi-e-tron') }}</span>
              <span v-else-if="post.industry === 'citroen-berlingo'">{{ $t('post.input-option-citroen-berlingo') }}</span>
              <span v-else-if="post.industry === 'ds-ds3-crossback-e-tens'">{{ $t('post.input-option-ds-ds3-crossback-e-tense') }}</span>
              <span v-else-if="post.industry === 'hyundai-ioniq-electric'">{{ $t('post.input-option-hyundai-ioniq-electric') }}</span>
              <span v-else-if="post.industry === 'hyundai-kona-electric-39-kwh'">{{ $t('post.input-option-hyundai-kona-electric-39-kwh') }}</span>
              <span v-else-if="post.industry === 'hyundai-kona-electric-64-kwh'">{{ $t('post.input-option-hyundai-kona-electric-64-kwh') }}</span>
              <span v-else-if="post.industry === 'jaguar-i-pace'">{{ $t('post.input-option-jaguar-i-pace') }}</span>
              <span v-else-if="post.industry === 'kia-e-niro'">{{ $t('post.input-option-kia-e-niro') }}</span>
              <span v-else-if="post.industry === 'mg-zs-ev'">{{ $t('post.input-option-mg-zs-ev') }}</span>
              <span v-else-if="post.industry === 'nissan-e-nv200-combi-visia'">{{ $t('post.input-option-nissan-e-nv200-combi-visia') }}</span>
              <span v-else-if="post.industry === 'nissan-e-nv200-visia'">{{ $t('post.input-option-nissan-e-nv200-visia') }}</span>
              <span v-else-if="post.industry === 'nissan-leaf'">{{ $t('post.input-option-nissan-leaf') }}</span>
              <span v-else-if="post.industry === 'peugeot-e-208'">{{ $t('post.input-option-peugeot-e-208') }}</span>
              <span v-else-if="post.industry === 'peugeot-partner'">{{ $t('post.input-option-peugeot-partner') }}</span>
              <span v-else-if="post.industry === 'renault-kangoo-crew-van-ze-33'">{{ $t('post.input-option-renault-kangoo-crew-van-ze-33') }}</span>
              <span v-else-if="post.industry === 'renault-kangoo-panel-van-ze-33'">{{ $t('post.input-option-renault-kangoo-panel-van-ze-33') }}</span>
              <span v-else-if="post.industry === 'renault-master-van-ze'">{{ $t('post.input-option-renault-master-van-ze') }}</span>
              <span v-else-if="post.industry === 'renault-twizy'">{{ $t('post.input-option-renault-twizy') }}</span>
              <span v-else-if="post.industry === 'renault-zoe'">{{ $t('post.input-option-renault-zoe') }}</span>
              <span v-else-if="post.industry === 'smart-eq-forfou'">{{ $t('post.input-option-smart-eq-forfou') }}</span>
              <span v-else-if="post.industry === 'smart-eq-fortwo-cabrio'">{{ $t('post.input-option-smart-eq-fortwo-cabrio') }}</span>
              <span v-else-if="post.industry === 'smart-eq-fortwo-coupé'">{{ $t('post.input-option-smart-eq-fortwo-coupé') }}</span>
              <span v-else-if="post.industry === 'tesla-model-3'">{{ $t('post.input-option-tesla-model-3') }}</span>
              <span v-else-if="post.industry === 'tesla-model-s'">{{ $t('post.input-option-tesla-model-s') }}</span>
              <span v-else-if="post.industry === 'tesla-model-x'">{{ $t('post.input-option-tesla-model-x') }}</span>
              <span v-else-if="post.industry === 'volkswagen-e-golf'">{{ $t('post.input-option-volkswagen-e-golf') }}</span>
              <span v-else-if="post.industry === 'volkswagen-e-up'">{{ $t('post.input-option-volkswagen-e-up') }}</span>  
              <br />
              <div v-if="post.price">
                <span v-if="post.currency === 'USD'" class="has-text-info">$</span>
                <span v-else-if="post.currency === 'GBP'" class="has-text-info">£</span>
                <span v-else-if="post.currency === 'EUR'" class="has-text-info">€</span>
                <span v-else-if="post.currency === 'AUD'" class="has-text-info">$</span>
                <span v-else-if="post.currency === 'CAD'" class="has-text-info">$</span>
                <span v-else-if="post.currency === 'JPY'" class="has-text-info">JP¥</span>
                <span v-else-if="post.currency === 'BRL'" class="has-text-info">R$</span>
                <span v-else-if="post.currency === 'INR'" class="has-text-info">₹</span>
                <span v-else-if="post.currency === 'CNY'" class="has-text-info">¥</span>
                <span v-else class="has-text-info">$</span>
                <span class="has-text-info">{{ post.price | formatCurrency }}</span>
                <span class="has-text-grey">({{ post.currency }})</span>

                <span v-if="post.pricetype === 'unit'" class="is-size-7">
                </span>
                <span v-else-if="post.pricetype === 'monthly'" class="is-size-7">
                  {{ $t('postdetails.per-month') }}
                </span>
                <span v-else-if="post.pricetype === 'annual'" class="is-size-7">
                  {{ $t('postdetails.per-year') }}
                </span>
                <span v-else class="has-text-info is-size-7">
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="level-right">
          <div v-if="post.email" class="has-margin-x-md has-margin-y-sm">
            {{ post.email }}
          </div>
          <!--
          <div class="has-margin-x-md has-margin-y-sm">
            <b-tooltip label="Add to Cart" position="is-top" type="is-black">
              <a class="button is-primary-grad is-rounded has-shadow">Enquire</a>
              <div v-if="!post.website">
            </b-tooltip>
          </div>-->
        </div>
      </nav>
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true">
        <div id="spinner"></div>
      </b-loading>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

import Navigation from '@/components/Navigation'

export default {
  data() {
    return {
      post: {
        id: "",
        odometer: "",
        odometermetric: "",
        range: "",
        rangemetric: "",
        battery: "",
        charging: "",
        acceleration: "",
        content: "",
        vehiclelocation: "",
        industry: "",
        imageUrl1: "",
        imageUrl2: "",
        email: "",
        phone: "",
        content: "",
        userName: "",
        userEmail: "",
        imageUrl1: "",
        imageUrl2: "",
        createdOn: "",
        industry: "",
        price: "",
        pricetype: "",
        currency: "",
      },
      comment: {
        postId: "",
        userId: "",
        content: "",
        postCommentsCounts: "",
        /*
        postCommentsCounts: 0,
        */
      },
      title: "",
      content: "",
      website: "",
      imageUrl: "",
      createdOn: "",

      fullPost: {},
      //storage: [],
      dropFile: [],
      file: null,
      
      postComments: [],

      isLoading: false,
      isFullPage: "",

      image:{
        size:'',
        height:'',
        width:''
      },
      imageError:'',
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "posts"])
  },

  beforeMount(){
    this.isLoading = true;
    this.showPost()
  },

  methods: {
    openLoading() {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 10 * 1000)
      console.log(this.$route.params)
    },

    showPost(){
      let docId = this.$route.params.id;
      console.log("showPost");
      console.log("docId = " + docId);
      fb.postsCollection
        .doc(docId)
        .get()
        .then(docs => {
          this.isLoading = false;

          //console.log(docs.id, ' => ', docs.data())
          console.log("docs title: " + docs.data().title);
          //console.log("docs comments: " + docs.data().comments);
          this.post.odometer = docs.data().odometer
          this.post.odometermetric = docs.data().odometermetric
          this.post.range = docs.data().range
          this.post.rangemetric = docs.data().rangemetric
          this.post.battery = docs.data().battery
          this.post.charging = docs.data().charging
          this.post.acceleration = docs.data().acceleration
          this.post.vehiclelocation = docs.data().vehiclelocation
          this.post.content = docs.data().content
          this.post.email = docs.data().email
          this.post.phone = docs.data().phone
          this.post.userName = docs.data().userName
          this.post.userEmail = docs.data().userEmail
          this.post.createdOn = docs.data().createdOn
          this.post.imageUrl1 = docs.data().imageUrl1
          this.post.imageUrl2 = docs.data().imageUrl2
          this.post.industry = docs.data().industry
          this.post.price = docs.data().price
          this.post.pricetype = docs.data().pricetype
          this.post.currency = docs.data().currency
          this.post.postID = docId

          this.post.comments = docs.data().comments
          
          
          //this.comment.userId = post.userId;
          this.comment.postCommentsCount = this.post.comments;
          this.comment.postId = docId;
          

          fb.commentsCollection
            .where("postId", "==", docId)
            .orderBy('createdOn', 'desc')
            .get()
            .then(docs => {
              let commentsArray = [];

              docs.forEach(doc => {
                this.comment.content = "";
                let comment = doc.data();
                comment.id = doc.id;
                commentsArray.push(comment);
              });

              this.postComments = commentsArray;
            })
            .catch(err => {
              console.log("coments err: " + err);
            });

        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
        });
    },

    addComment() {
      let postId = this.comment.postId;
      let postCommentsCount = this.comment.postCommentsCount;
      //let postComments = this.comment.postComments;
      
      fb.commentsCollection
        .add({
          createdOn: new Date(),
          content: this.comment.content,
          postId: postId,
          userId: this.currentUser.uid,
          userName: this.userProfile.name
        })
        .then(() => {
          fb.postsCollection
            .doc(postId)
            .update({
              comments: postCommentsCount + 1
            })
            .then(() => {
              this.postComments = "";
              this.isLoading = true;
              this.showPost();
            });
        })
        .catch(err => {
          console.log(err);
        });
    },

    deleteComment(comment) {
      this.isLoading = true;
      let docId = `${comment.id}`;

      let postId = this.comment.postId;
      let postComments = this.comment.postComments;
      let commentTotal = this.post.comments;

      fb.commentsCollection
        .doc(docId)
        .delete()
        .then(() => {
          console.log('delete commentTotal: ' + commentTotal);
          fb.postsCollection
            .doc(postId)
            .update({
              comments: commentTotal - 1
            })
            .then(() => {
              this.isLoading = false;
              this.showPost();
              this.$toast.open({
                message: this.$t("posts.toast-comment-deleted"),
                queue: false,
                type: "is-success"
              });
            })
        })
        .catch(err => {
          console.log(err);
          this.$toast.open({
            message: this.$t("posts.toast-error"),
            queue: false,
            type: "is-warning"
          });
        });
    },
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    
    formatCurrency (value) {
      if (isNaN(parseFloat(value))) {
          return value;
      }
      var formatter = new Intl.NumberFormat('en-IN', { 
        minimumFractionDigits: 0 })

      return formatter.format(value);
    },

    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    }
  },

  components: {
    Navigation
  },
}
</script>